import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import moment from "moment";


export const getOrdinal = (number) =>
  number +
  (number % 10 === 1 && number % 100 !== 11
    ? "st"
    : number % 10 === 2 && number % 100 !== 12
    ? "nd"
    : number % 10 === 3 && number % 100 !== 13
    ? "rd"
    : "th");
const ordinals = [
  "First",
  "second",
  "Third",
  "Fourth",
  "Fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
  "Tenth",
];

const TableRow = ({ rowTitleOne, rowTitleTwo, rowAnsOne, rowAnsTwo }) => {
  return (
    <View
      style={{
        flexDirection: "row",
        fontSize: 8,
        gap: 10,
        borderBottomWidth: 0.5,
        padding: 2,
        width: "100%",
      }}
    >
      <View style={{ width: "50%", flexDirection: "row", alignItems: 'center',height: 15  }}>
        <Text
          style={{
            width: "100px",
            fontWeight: "bold",
            fontFamily: "Times-Bold",
          }}
          colspan="2"
        >
          {rowTitleOne}
        </Text>
        <Text style={{}}>: {rowAnsOne}</Text>
      </View>
      <View style={{ width: "50%", flexDirection: "row", alignItems: 'center',height: 15  }}>
        <Text
          style={{
            width: "100px",
            fontWeight: "bold",
            fontFamily: "Times-Bold",
          }}
          colspan="2"
        >
          {rowTitleTwo}
        </Text>
        <Text style={{}}>: {rowAnsTwo}</Text>
      </View>
    </View>
  );
};

const DepositSlipDetails = ({
  sNo,
  installmentName,
  dueDate,
  mrp,
  concessionPer,
  lumpSumPercent,
  concessionAmount,
  totalTax,
  netPayableAmount,
  alreadyPaid,
  balancePayable,
}) => {
  return (
    <View
    wrap={false}
      style={{
        pageBreakInside: 'avoid',
        flexDirection: "row",
        fontSize: 8,
        gap: 10,
        padding: 0,
        width: "100%",
        borderBottomWidth: .5,
      }}
    >
      <Text
        style={{
          width: "40px",
          
          padding: 3,
          borderRightWidth: .5,
          borderLeftWidth: .5,
          textAlign: 'center'
        }}
      >
        {sNo}
      </Text>
      <Text
        style={{
          width: "190px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'center'
        }}
      >
        {installmentName}
      </Text>
      <Text
        style={{
          width: "100px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'center'
        }}
      >
        {dueDate}
      </Text>
      <Text
        style={{
          width: "80px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'right'
        }}
      >
        {mrp}
      </Text>
      <Text
        style={{
          width: "80px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'center'
        }}
      >
        {concessionPer}
      </Text>
      <Text
        style={{
          width: "60px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'center'
        }}
      >
        {lumpSumPercent}
      </Text>
      <Text
        style={{
          width: "60px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'right'
        }}
      >
        {concessionAmount}
      </Text>
      <Text
        style={{
          width: "80px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'right'
        }}
      >
        {totalTax}
      </Text>
      <Text
        style={{
          width: "80px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'right'
        }}
      >
        {netPayableAmount}
      </Text>
      <Text
        style={{
          width: "80px",
          
          padding: 3,
          borderRightWidth: .5,
          textAlign: 'right'
        }}
      >
        {alreadyPaid}
      </Text>
      <Text style={{ width: "80px", borderRightWidth: .5, padding: 3,textAlign: 'right' }}>
        {balancePayable}
      </Text>
    </View>
  );
};

const Header = () => (
  <View style={styles.header} fixed>
    <Image
      style={styles.logo}
      src="data:image/png;base64,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"
    />
  </View>
);

const DraftSummary = ({data, qrCode}) => {
  return (
    <>
      <View style={styles.content}>
        <Header />
        <View style={styles.draftSummeryContainer}>
          <View style={styles.draftSummeryLogo}>
          </View>
          <View style={styles.draftSummeryContactUs}>
            <View style={styles.draftSummeryAddress}>
              <Text style={{ textAlign: "center", fontSize: 10 }}>
                <Text style={{ fontWeight: "bold",fontFamily: 'Times-Bold' }}>
                  Academic branch address{" "}
                </Text>
                - SCO - 367-368 Ground floor Sector-34A chandighar CH-160034
              </Text>
            </View>
            <View style={styles.draftSummeryAddress}>
              <Text style={{ fontWeight: "bold", fontSize: 10, fontFamily: 'Times-Bold' }}>
                Website:- www.aakash.ac.in
              </Text>
            </View>
            <Text style={{ textAlign: "center", fontSize: 14 , fontWeight: "bold",fontFamily: 'Times-Bold'}}>
              Draft Summary of Student Charges{" "}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "column",
              borderWidth: .5,
              marginTop: 10,
            }}
          >
            <View style={{ width: "100%", borderWidth: .5 }}>
              <Text
                style={{
                  textAlign: "center",
                  backgroundColor: "#0070C0",
                  width: "100%",
                  color: "white",
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: 'Times-Bold',
                  padding: 2,
                }}
                colspan="8"
              >
                Student Details
              </Text>
            </View>
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                borderWidth: .5,
              }}
            >
              {/* {data.map((item) => {
                return ( */}
              <View style={{ width: "80%" }}>
                <TableRow
                  key={data?.sNo}
                  rowTitleOne={"Student ID"}
                  rowTitleTwo={"Academic Branch"}
                  rowAnsOne={data?.studentId}
                  rowAnsTwo={`${data?.acadamicBranch} (${
                    data?.acadamicBranchLabel ?? ""
                  })`}
                />

                <TableRow
                  rowTitleOne={"Application Number"}
                  rowTitleTwo={"Sales Branch"}
                  rowAnsOne={data?.applicationNumber}
                  rowAnsTwo={data?.salesBranch}
                />
                <TableRow
                  rowTitleOne={"Name"}
                  rowTitleTwo={"Email Address"}
                  rowAnsOne={data?.name}
                  rowAnsTwo={data?.emailAddress}
                />
                <TableRow
                  rowTitleOne={"Father Name"}
                  rowTitleTwo={"Issue Date"}
                  rowAnsOne={data?.fatherName}
                  rowAnsTwo={moment(data?.issueDate).format('DD-MM-YYYY')}
                />
                <TableRow
                  rowTitleOne={"Address"}
                  rowTitleTwo={"Bajaj fin unique ID"}
                  rowAnsOne={data?.address}
                  rowAnsTwo={data?.bajajFinUniqueId}
                />
                <TableRow
                  rowTitleOne={"VPA Address"}
                  rowTitleTwo={"Net Payable (incl. tax)"}
                  rowAnsOne={data?.vpaAddress}
                  rowAnsTwo={data?.netPayable}
                />
                <TableRow
                  rowTitleOne={"Total MRP"}
                  rowTitleTwo={"Total paid till date"}
                  rowAnsOne={data?.totalMrp}
                  rowAnsTwo={data?.totalPaidTillDate}
                />
                <TableRow
                  rowTitleOne={"Total Concession"}
                  rowTitleTwo={"Balance Payable"}
                  rowAnsOne={data?.totalConcession}
                  rowAnsTwo={data?.balancePayable}
                />
                <TableRow
                  rowTitleOne={"Term"}
                  rowTitleTwo={"Unique ID"}
                  rowAnsOne={data?.term}
                  rowAnsTwo={data?.uniqueId}
                />
                {/* <TableRow
                  rowTitleOne={"IFSC Code"}
                  rowTitleTwo={"Beneficiary Name"}
                  rowAnsOne={data?.ifscCode}
                  rowAnsTwo={data?.beneficiaryName}
                /> */}
                <View
                  style={{
                    flexDirection: "row",
                    fontSize: 8,
                    gap: 10,
                    padding: 2,
                  }}
                >
                  <View style={{ width: "50%", flexDirection: "row" }}>
                    <View style={{ width: "50%", flexDirection: "row" }}>
                      <Text
                        style={{ width: "50px", fontWeight: "bold", fontFamily: 'Times-Bold' }}
                        colspan="1"
                      >
                        VAN Details
                      </Text>
                      <Text style={{}}>: {data?.vanDetails}</Text>
                    </View>
                    <View style={{ width: "50%", flexDirection: "row" }}>
                      <Text
                        style={{ width: "50px", fontWeight: "bold", fontFamily: 'Times-Bold' }}
                        colspan="1"
                      >
                        IFSC Code
                      </Text>
                      <Text style={{}}>: {data?.ifscCode}</Text>
                    </View>
                  </View>
                  <View style={{ width: "50%", flexDirection: "row" }}>
                    <Text
                      style={{ width: "100px", fontWeight: "bold", fontFamily: 'Times-Bold' }}
                      colspan="1"
                    >
                      Beneficiary Name
                    </Text>
                    <Text style={{}}>: {data?.beneficiaryName}</Text>
                  </View>
                </View>
              </View>
              {/* );
              })} */}
              <View
                style={{
                  borderLeftWidth: .5,
                  alignItems: "center",
                  justifyContent: "center",
                  width: "20%",
                }}
              >
                <View
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 10,
                  }}
                >
                  <Image
                    style={{ width: "120px" }}
                    src={`${qrCode}`}
                  />

                  <Text
                    style={{
                      color: "red",
                      fontWeight: "extrabold",
                      fontSize: 8,
                      marginTop: 5,
                      fontWeight: "bold",fontFamily: 'Times-Bold'
                    }}
                  >
                    Scan QR code for payment
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View>
            {/* <Text style={{ fontSize: 10, margin: 10 }}>
              Course ID : 712451 (Two Year Integrated Classroom Course for NEET)
            </Text> */}
            <View>
              {Object.keys(data.installments).map((year) => {
                return (
                  <View key={`${data?.courseId}-${year}`} style={{marginTop: 10}}>
                    <Text style={{ fontSize: 10,  fontWeight: "bold",fontFamily: 'Times-Bold' }}>
                      Course ID :{" "}
                      <Text style={{fontSize: 10, fontWeight: 100}}>{`${data?.courseId ?? ""}`} </Text>
                      <Text style={{ fontSize: 10, fontWeight: "bold",fontFamily: 'Times-Bold' }}> {`(${data?.courseName ?? ""})`}</Text>
                    </Text>
                    <View
                      style={{
                        
                        flexDirection: "column",
                        // borderWidth: .5,
                      }}
                    >
                      <View fixed 
                      style={{ 
                        width: "100%",
                        borderWidth: .5 
                        }}>
                        <Text
                          style={{
                            textAlign: "center",
                            backgroundColor: "#0070C0",
                            width: "100%",
                            color: "white",
                            fontSize: 10,
                            fontWeight: "bold",
                            fontFamily: 'Times-Bold',
                            padding: 2,
                          }}
                          colspan="8"
                        >
                          Student Draft Summary Report{" "}
                          {`(${getOrdinal(year)} Year)`}
                        </Text>
                      </View>
                      <View 
                      style={{ 
                        width: "100%", 
                        // borderWidth: .5 
                        }}>
                        <View
                          fixed
                          style={{
                            flexDirection: "row",
                            fontSize: 8,
                            gap: 10,
                            padding: 0,
                            width: "100%",
                            // borderBottomWidth:1,
                            backgroundColor: "#E6F3FD",
                          }}
                        >
                          <Text
                            style={{
                              width: "40px",
                              padding: 3,
                              borderRightWidth: .5,
                              borderLeftWidth: .5,
                              textAlign: 'center',
                              fontWeight: "bold",fontFamily: 'Times-Bold'
                            }}
                          >
                            S.No.
                          </Text>
                          <Text
                            style={{
                              width: "190px",
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center',
                              fontWeight: "bold",fontFamily: 'Times-Bold'
                            }}
                          >
                            Installment Name
                          </Text>
                          <Text
                            style={{
                              width: "100px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            Due Date
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            MRP
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            Concession %
                          </Text>
                          <Text
                            style={{
                              width: "60px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            Lump Sum Percent
                          </Text>
                          <Text
                            style={{
                              width: "60px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            Concession Amount
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            Total Tax
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            Net Payable Amount
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'center'
                            }}
                          >
                            Already Paid
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              padding: 3,
                              textAlign: 'center',
                              borderRightWidth: .5,
                            }}
                          >
                            Balance Payable
                          </Text>
                        </View>
                        {data.installments[year].map((item, i) => {
                          return (
                            <DepositSlipDetails
                              key={`${item.installmentName}-${i + 1}`}
                              sNo={i + 1}
                              installmentName={item.installmentName}
                              dueDate={item.dueDate}
                              mrp={item.mrp}
                              concessionPer={item.concessions}
                              lumpSumPercent={item.lumpSumPerscent}
                              concessionAmount={item.concessionAmount}
                              totalTax={item.totalTax}
                              netPayableAmount={item.netPayable}
                              alreadyPaid={item.alreadyPaid}
                              balancePayable={item.balancePending}
                            />
                          );
                        })}

                        <View
                          style={{
                            flexDirection: "row",
                            fontSize: 8,
                            gap: 10,
                            padding: 0,
                            width: "100%",
                            borderBottomWidth: .5,
                            pageBreakInside: 'avoid',
                          }}
                        >
                          <Text
                            style={{
                              width: "330px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                              borderLeftWidth: .5,
                            }}
                          >
                            {`Grand Total for ${ordinals[year - 1]} Year`}
                          </Text>

                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'right'
                            }}
                          >
                            {data?.yearWiseTotal?.[year]?.totalMrp ?? "0.00"}
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                            }}
                          ></Text>
                          <Text
                            style={{
                              width: "60px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                            }}
                          ></Text>
                          <Text
                            style={{
                              width: "60px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'right'
                            }}
                          >
                            {data?.yearWiseTotal?.[year]?.totalConcession ??
                              "0.00"}
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'right'
                            }}
                          >
                            {data?.yearWiseTotal?.[year]?.totalTotalTax ??
                              "0.00"}
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'right'
                            }}
                          >
                            {data?.yearWiseTotal?.[year]?.totalNetPayable ??
                              "0.00"}
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              padding: 3,
                              borderRightWidth: .5,
                              textAlign: 'right'
                            }}
                          >
                            {data?.yearWiseTotal?.[year]?.totalAlreadyPaid ??
                              "0.00"}
                          </Text>
                          <Text
                            style={{
                              width: "80px",
                              borderRightWidth: 0.5,
                              padding: 3,
                              fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                              textAlign: 'right'
                            }}
                          >
                            {data?.yearWiseTotal?.[year]?.totalBalancePending ??
                              "0.00"}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                );
              })}
            </View>
            <View>
              {/* Grand Total for Course  */}
              <View
                style={{
                  marginTop: 20,
                  flexDirection: "row",
                  fontSize: 8,
                  gap: 10,
                  padding: 0,
                  width: "100%",
                  borderWidth: .5,
                }}
              >
                <Text
                  style={{
                    width: "230",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                  }}
                >
                  Grand Total for Course
                </Text>

                <Text
                  style={{
                    width: "100px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                  }}
                >
                  
                </Text>
                <Text
                  style={{
                    width: "80px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                    textAlign: 'right'
                  }}
                >
                  {data.grandTotal?.totalMrp ?? '0.00'}
                </Text>
                <Text
                  style={{
                    width: "80px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                  }}
                >
                  
                </Text>
                <Text
                  style={{
                    width: "60px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                  }}
                >
                  
                </Text>
                <Text
                  style={{
                    width: "60px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                    textAlign: 'right'
                  }}
                >
                  {data.grandTotal?.totalConcession ?? '0.00'}
                </Text>
                <Text
                  style={{
                    width: "80px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                    textAlign: 'right'
                  }}
                >
                   {data.grandTotal?.totalTotalTax ?? '0.00'}
                </Text>
                <Text
                  style={{
                    width: "80px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                    textAlign: 'right'
                  }}
                >
                  {data.grandTotal?.totalNetPayable ?? '0.00'}
                </Text>
                <Text
                  style={{
                    width: "80px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    borderRightWidth: .5,
                    textAlign: 'right'
                  }}
                >
                  {'0.00'}
                </Text>
                <Text
                  style={{
                    width: "80px",
                    fontWeight: "bold",fontFamily: 'Times-Bold',
                              fontSize: 10,
                    padding: 3,
                    textAlign: 'right'
                  }}
                >
                  {data.grandTotal?.totalBalancePending ?? '0.00'}
                </Text>
              </View>
            </View>
          </View>
          {/* note and disclaimer */}
          <View style={{ marginTop: 5, rowGap: 5 }}>
            <View style={{ flexDirection: "row", rowGap: 3 }}>
              <Text style={{ width: "140px", fontSize: 9, fontWeight: "bold", fontFamily: 'Times-Bold', }}>Note :</Text>
              <Text style={{ width: "65%", fontSize: 9,lineHeight: 1.2 }}>
                This Summary sheet is for review and confirmation of details
                including fees and concessions by the parents/student. This does
                not guarantee Admission. <br />
                Please note that it is mandatory to pay Security Deposit as
                stated in the prospectus on or before payment of 1st Installment
                for confirmed admission.
              </Text>
            </View>
            <View style={{ flexDirection: "row", rowGap: 3 }}>
              <Text style={{ width: "140px", fontSize: 9, fontWeight: "bold", fontFamily: 'Times-Bold', }}>Disclaimer :</Text>
              <Text style={{ width: "65%", fontSize: 9, lineHeight: 1.2 }}>
                In case the concession category selected is subject to the
                approval of higher authorities, then the concession provided
                above might vary.
              </Text>
            </View>
            <View style={{ flexDirection: "row", lineHeight: 1.2 }}>
              <Text style={{ width: "140px", fontSize: 9, fontWeight: "bold", fontFamily: 'Times-Bold', }}>Instruction :</Text>
              <View style={{ width: "65%", fontSize: 9, gap: 3, rowGap: 3 }}>
                <Text style={{lineHeight: 1.2}}>
                  1. In case fees for the course exceeds Rs. 2 Lacs, payment by
                  cash will be restricted to a sum lesser than or equal to 2
                  Lacs and the balance needs to be paid by Cheque / DD / Credit
                  / Debit Card / Net Banking.
                </Text >
                <Text style={{lineHeight: 1.2}}>
                  2. Slips for 2-year courses have been generated for 1st year
                  only. For 2nd year, the same will be provided at the start of
                  the 2nd year.
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  3.If second-year PDCs are not realized within 25 days of the
                  start of the second year, the lump sum discount on the
                  second-year fee will be reversed.
                </Text>
              </View>
            </View>
            <View style={{ flexDirection: "row" }}>
              <View style={{ width: "140px",fontSize: 9 }}>
                <Text style={{fontWeight: "bold", fontFamily: 'Times-Bold'}}>TERMS AND CONDITIONS:</Text>
              </View>
              <View style={{ width: "65%", fontSize: 9, gap: 3 }}>
                <Text style={{lineHeight: 1.2}}>
                  1. AESL shall not be liable/responsible, in case a loan is
                  availed from any financing partner either partially or in
                  full.
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  2. It is the sole discretion of the customer to avail the loan
                  from the financing partner, at its own risk. AESL does not
                  promote its
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  3. customer to avail of the facilities from the financing
                  partner.
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  4. Customers can opt for either issue of PDC as a mode of
                  payment or they can opt for e-mandate as the alternative.
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  5. E-mandate is just to facilitate the customer to clear the
                  outstanding on time, thereby providing an auto-debit facility.
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  6. The customer shall maintain the minimum balance at all
                  times to avoid a levy of penalty, as per the policy of AESL.
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  7. An additional concession of 7.5% on tuition fees and class
                  fees is also available in case of 100% course fee loan is
                  sanctioned by Bajaj Finance Limited. It is also clarified that
                  if the loan is sanctioned for part payment of the course fee,
                  above mentioned additional concession of 7.5% of the tuition
                  fee and class fee shall be applicable proportionately on loan
                  sanctioned amount as well as unsanctioned loan
                  amount/un-availed amount subject to depositing of Post Dated
                  Cheques by the customer with AESL for the remaining course fee
                  within 15 days from the charge finalization date, and not
                  otherwise.
                </Text>
                <Text style={{lineHeight: 1.2}}>
                  8. Discretionary Concession % has been sent to Corporate
                  Office for approval and hence, revised confirmation through
                  mail shall be intimated once the total concession is finally
                  approved.
                </Text>
              </View>
            </View>
          </View>
          <View style={{ flexDirection:'row', gap: 30, alignItems: "center", justifyContent:'flex-end', marginTop: 50,marginRight:20}}>
            <Text style={{fontSize: 10,fontWeight: "bold",fontFamily: 'Times-Bold'}}>BM/Counsellor's Signature</Text>
            <Text style={{fontSize: 10,fontWeight: "bold",fontFamily: 'Times-Bold'}}>Parent's Signature</Text>
          </View>
        </View>

        <Text
          style={styles.pageNumbers}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </View>
    </>
  );
};
const styles = StyleSheet.create({
  tableRow: {
    flexDirection: "row",
    fontSize: 8,
    gap: 10,
  },
  header: {
    alignSelf: "center",
    textAlign: "center",
    marginBottom: 10,
    width: "100px",
  },
  page: {
    paddingTop: 20,
    paddingBottom: 40,
    paddingHorizontal: 10,
  },
  content: {
    flexGrow: 1,
  },
  pageNumbers: {
    position: "absolute",
    bottom: -10,
    // left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
  },
  table: {
    display: "table",
    width: "auto",
    margin: 10,
    borderStyle: "solid",
    borderWidth: .5,
    borderCollapse: "collapse",
  },
  // tableRow: {
  //   margin: "auto",
  //   flexDirection: "row",
  // },
  tableCellHeader: {
    width: "33.33%",
    backgroundColor: "#eee",
    borderStyle: "solid",
    borderWidth: .5,
    padding: 5,
    textAlign: "center",
  },
  tableCell: {
    width: "33.33%",
    borderStyle: "solid",
    borderWidth: .5,
    padding: 5,
    textAlign: "center",
  },
  draftSummeryContactUs: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 5,
  },
});

export default DraftSummary;